
import React from 'react';
import { Home, BarChart, PlusCircle, Star, User } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import { cn } from '@/lib/utils';

interface MobileBottomNavProps {
  onCreateClick: () => void;
}

const MobileBottomNav = ({ onCreateClick }: MobileBottomNavProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  const items = [
    { icon: Home, label: 'Accueil', href: '/' },
    { icon: BarChart, label: 'Stats', href: '/dashboard' },
    { icon: PlusCircle, label: 'Signaler', action: onCreateClick, highlight: true },
    { icon: Star, label: 'Favoris', href: '/favorites' },
    { icon: User, label: 'Profil', href: '/auth' },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-background/95 backdrop-blur-md border-t border-border md:hidden safe-area-bottom">
      <div className="flex items-center justify-around h-16 px-2">
        {items.map((item) => {
          const isActive = item.href ? location.pathname === item.href : false;

          return (
            <button
              key={item.label}
              onClick={() => {
                if (item.action) {
                  item.action();
                } else if (item.href) {
                  navigate(item.href);
                }
              }}
              className={cn(
                "flex flex-col items-center justify-center gap-0.5 flex-1 py-1 transition-colors",
                item.highlight
                  ? "text-primary"
                  : isActive
                    ? "text-primary"
                    : "text-muted-foreground"
              )}
            >
              <item.icon
                className={cn(
                  "h-5 w-5 transition-transform",
                  item.highlight && "h-7 w-7 -mt-3 bg-primary text-primary-foreground rounded-full p-1",
                  isActive && !item.highlight && "scale-110"
                )}
              />
              <span className={cn(
                "text-[10px] font-medium",
                item.highlight && "-mt-0.5"
              )}>
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileBottomNav;
